<template>
  <div class="sidebar">
    <div class="profileset">
      <h4>{{user.name | capitalize}}</h4>
      <span>{{user.role | capitalize}}</span>
    </div>
    <div class="sidenavbar">
      <h1>Welcome, {{user.firstname | capitalize}}</h1>
      <b-nav vertical class="accountnav">
        <b-nav-item class="activenav" to="/shop/account">
          <b-img class="accounticn" src="/shop/images/account.svg"></b-img>Account
        </b-nav-item>
        <b-nav-item to="/shop/orders">
          <b-img class="accounticn" src="/shop/images/orders.svg"></b-img>Orders
        </b-nav-item>
        <b-nav-item to="/shop/invoices">
          <b-img class="accounticn" src="/shop/images/invoice.svg"></b-img>Invoices
        </b-nav-item>
        <b-nav-item to="/shop/projects">
          <b-img class="accounticn" src="/shop/images/project.svg"></b-img>Projects
        </b-nav-item>
        <!-- <b-nav-item to="#">
          <b-img class="accounticn" src="/shop/images/resources.svg"></b-img>Resources
        </b-nav-item> -->
        <b-nav-item to="/shop/pricesheet">
          <b-img class="accounticn" src="/shop/images/pricebook.svg"></b-img>Price Sheet By Book
        </b-nav-item>
        <!-- <b-nav-item to="#">
          <b-img class="accounticn" src="/shop/images/helpcenter.svg"></b-img>Help Center
        </b-nav-item> -->
      </b-nav>
    </div>
  </div>
</template>

<script>
import ResourceMixin from "../mixins/resources";
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["user"])
  }
};
</script>
<style>
.sidebar {
  width: 26.3%;
  position: relative;
  background: #ececec;
  height: 100%;
  float: left;
  padding: 40px 20px 40px 20px;
  box-sizing: border-box;
  position: fixed;
  z-index: 2;
  top: 125px;
}
.sidebar .sidenavbar {
  max-width: 230px;
  float: right;
  width: 100%;
}
.sidebar h1 {
  margin-bottom: 40px;
  text-align: left;
}
.sidebar ul.accountnav li {
  line-height: 70px;
  margin: 0;
  padding: 0;
  position: relative;
}
.sidebar ul.accountnav li a {
  font-size: 16px;
  color: #777777;
  text-decoration: none;
  margin: 0;
  padding: 0;
  border-bottom: 1px solid #d2d2d2;
  font-weight: 500;
}
.sidebar ul.accountnav li a.is-active {
  color: #303030;
}
.sidebar ul.accountnav li a:hover{
  color: #303030;
}
.sidebar ul.accountnav li a.is-active::after {
  content: "";
  background: url(/shop/images/arrow.svg) no-repeat center;
  height: 12px;
  width: 12px;
  background-size: cover;
  position: absolute;
  right: 0;
  top: 29px;
  transform: rotate(-90deg);
}
.sidebar ul.accountnav li a img {
  width: 20px;
  height: 20px;
  float: left;
  margin-top: 24px;
  margin-right: 20px;
}
@media only screen and (min-width:1441px) and (max-width:1680px){
	.sidebar{
		width:26.3%;
	}
	.sidebar .sidenavbar{
		max-width:290px;
	}
}
@media only screen and (max-width: 1440px) {
  .sidebar {
    width: 26.3%;
  }
  .sidebar .sidenavbar {
    max-width: 250px;
  }
}
@media only screen and (max-width: 1367px) {
  .sidebar .sidenavbar {
    max-width: 280px;
  }
}
@media only screen and (max-width: 1360px) {
  .sidebar {
    width: 350px;
  }
}
@media only screen and (max-width: 1199px) and (min-width: 1025px) {
  .sidebar {
      width: 300px;
  }
}
@media only screen and (max-width:1024px) and (min-width:768px){
	.sidebar {
		width: 260px;
		top:105px;
	}
	.sidebar h1{
		margin-bottom:10px;
	}
	.headwrap.positionfix + .accountdetails .sidebar, .headwrap.positionfix + .accountdetails.mainprojectsection .orderspage.projectspage .projectlistbar {
		top: 70px;
	  }
	.sidebar .sidenavbar {
		max-width: 230px;
	}
	.sidebar ul.accountnav li a{
		font-size:14px;
	}
	.sidebar ul.accountnav li a img{
		margin-right:10px;
	}
}
@media only screen and (max-width: 767px){
  .myaccount .sidebar,.pricesheetpage .sidebar{
	display:none;
  }
  .sidebar h1{
    margin-bottom: 10px;
  }
}
</style>
